import { InternalAxiosRequestConfig } from "axios";

export const CURRENT_CAMPAIGN_STORAGE_KEY = "currentCampaignId";

const ITEM_PATH = /^\/api\/(products|ingredients|packagings|packaging-elements|packaging-composites)(\/[^/?]+)?(\?|$)/;
const SSQ_POST_PATH = /^\/api\/ssq-posts\/[^/?]+(\/values)?(\?|$)/;

const getPathname = (url: string | undefined): string | undefined => {
    if (url === undefined) {
        return undefined;
    }

    const withoutOrigin = url.replace(/^https?:\/\/[^/]+/, "");
    const pathStart = withoutOrigin.indexOf("/api/");

    return pathStart === -1 ? undefined : withoutOrigin.slice(pathStart);
};

export const isCampaignScopedRequest = (method: string | undefined, url: string | undefined): boolean => {
    const path = getPathname(url);
    if (path === undefined) {
        return false;
    }

    if (SSQ_POST_PATH.test(path)) {
        return true;
    }

    return (method ?? "get").toLowerCase() === "get" && ITEM_PATH.test(path);
};

export const getViewedCampaignId = (): number | null => {
    try {
        const raw = localStorage.getItem(CURRENT_CAMPAIGN_STORAGE_KEY);
        const id = raw === null ? Number.NaN : Number(raw);

        return Number.isInteger(id) && id > 0 ? id : null;
    } catch {
        return null;
    }
};

const hasCampaignParam = (config: InternalAxiosRequestConfig): boolean => {
    const params = config.params as Record<string, unknown> | undefined;
    if (params?.campaign !== undefined) {
        return true;
    }

    return /[?&]campaign=/.test(config.url ?? "");
};

export const withViewedCampaign = (
    config: InternalAxiosRequestConfig,
    campaignId: number | null = getViewedCampaignId(),
): InternalAxiosRequestConfig => {
    if (campaignId === null || !isCampaignScopedRequest(config.method, config.url) || hasCampaignParam(config)) {
        return config;
    }

    config.params = { ...(config.params as Record<string, unknown> | undefined), campaign: campaignId };

    return config;
};
